module.exports = __webpack_public_path__ + "static/Background-gov-1.b4b0ea39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-gov-1.jpg
// module id = 466
// module chunks = 53566712009029